export default "__VITE_ASSET__DaRlMY5___"